"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Rewards API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateGiveawaySchedulerConfigRequestToJSON = exports.UpdateGiveawaySchedulerConfigRequestFromJSONTyped = exports.UpdateGiveawaySchedulerConfigRequestFromJSON = exports.instanceOfUpdateGiveawaySchedulerConfigRequest = void 0;
var runtime_1 = require("../runtime");
var GiveawaySchedulerConfigStatus_1 = require("./GiveawaySchedulerConfigStatus");
/**
 * Check if a given object implements the UpdateGiveawaySchedulerConfigRequest interface.
 */
function instanceOfUpdateGiveawaySchedulerConfigRequest(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfUpdateGiveawaySchedulerConfigRequest = instanceOfUpdateGiveawaySchedulerConfigRequest;
function UpdateGiveawaySchedulerConfigRequestFromJSON(json) {
    return UpdateGiveawaySchedulerConfigRequestFromJSONTyped(json, false);
}
exports.UpdateGiveawaySchedulerConfigRequestFromJSON = UpdateGiveawaySchedulerConfigRequestFromJSON;
function UpdateGiveawaySchedulerConfigRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'repeatTimes': !(0, runtime_1.exists)(json, 'repeatTimes') ? undefined : json['repeatTimes'],
        'durationTime': !(0, runtime_1.exists)(json, 'durationTime') ? undefined : json['durationTime'],
        'status': !(0, runtime_1.exists)(json, 'status') ? undefined : (0, GiveawaySchedulerConfigStatus_1.GiveawaySchedulerConfigStatusFromJSON)(json['status']),
    };
}
exports.UpdateGiveawaySchedulerConfigRequestFromJSONTyped = UpdateGiveawaySchedulerConfigRequestFromJSONTyped;
function UpdateGiveawaySchedulerConfigRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'repeatTimes': value.repeatTimes,
        'durationTime': value.durationTime,
        'status': (0, GiveawaySchedulerConfigStatus_1.GiveawaySchedulerConfigStatusToJSON)(value.status),
    };
}
exports.UpdateGiveawaySchedulerConfigRequestToJSON = UpdateGiveawaySchedulerConfigRequestToJSON;
